module.exports = "https://www.gc-pro.gnp.com.mx/df2eb4ec16fd4636f092c95f171c58f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/error_outline_24px.png
// module id = 8103
// module chunks = 0